import { Container } from "@material-ui/core";
import useStyles from "../styles/css";

function Copyrigth() {
 const css = useStyles();

 return (
  <Container className={css.textAlignCenter}>
   <hr />
   <h2>Copyrigth</h2>
   <hr />

   <h3>Data Protection</h3>
   <p>The user is guaranteed the non-disclosure of his data under the laws that protect him.</p>
   <hr />

   <h3>Intellectual and industrial property</h3>
   <p>All copyrights generated by the site are protected, such as content, audios, videos, logos, among others.</p>
   <hr />

   <h3>Right of exclusion</h3>
   <p>The website reserves the right to restrict access to any registered user.</p>
   <hr />

   <h3>Legal notice and conditions of use</h3>
   <p>By using our Website it is understood that you accept our Legal Notice and Conditions of Use, Privacy Policies and Cookies Policies.</p>
   <hr />

   <h3>Exclusion of guarantees and responsibilities</h3>
   <p>The website is exempt from all damages caused by it, for example, the unavailability of the site.</p>
   <hr />

   <h3>Modifications</h3>
   <p>The site reserves the right to make the necessary modifications, even if its functionalities are no longer valid.</p>
   <hr />

   <h3>Cookies</h3>
   <p>Session storege.</p>
   <p>Session storege.</p>
   <p>Indexed databases.</p>
   <hr />
  </Container>
 );
}

export default Copyrigth;
